export default __webpack_public_path__ + "static/media/sub-event-pool.f3ba91a6.png";